// extracted by mini-css-extract-plugin
export default {"card":"Welcome_card__IFJcN","body":"Welcome_body__BC6s4","button":"Welcome_button__z2Yto"};